import graphql from "babel-plugin-relay/macro";

export const billingGroupDropdown = graphql`
fragment BillingGroupFragments_BillingGroupDropdown on BillingGroup @relay(plural: true) {
    id
    name
    tin
    legalContract {
        id
    }
}`